import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

function SellerAutocomplete(props) {
  const { label, required, onChange, disabled = false } = props;

  return (
    <Autocomplete
      disableClearable
      options={props.sellers || []}
      disabled={disabled}
      getOptionLabel={(option) => option.SlpName}
      renderInput={(params) => (
        <TextField {...params} label={label} margin="normal" required={required} />
      )}
      onChange={onChange}
    />
  );
}

export default SellerAutocomplete;
